/*
 * @Author: 卢靖康
 * @Date: 2020-12-11 14:48:00
 * @LastEditTime: 2020-12-11 14:49:53
 * @LastEditors: 卢靖康
 */
var io = require('../io');
module.exports = function (inOpts) {
    inOpts.url = io.b2bCgiUrl;
    inOpts.cmd = 'user/syncUserAddressData';
    io.ajax(inOpts);
};



//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/login/syncUserAddressData.js
// module id = 120
// module chunks = 1 6 32